// Single source of truth for the Mudugudu dashboard's navigation.
//
// Two levels, exactly like the Isibo dashboard:
//   Level 1 (sidebar): ONE button per group — icon + label only, no
//     sub-items shown here. Clicking a group with a single child goes
//     straight to that page; clicking a group with several children opens
//     that group's ModuleOverviewPage (a card grid) in the main area.
//   Level 2 (ModuleOverviewPage): the group's children as cards; clicking
//     a card sets the tab to that child's `key`, rendering its existing
//     page component (see renderContent() in page/Mudugudu.jsx).
//
// Every child `key` matches a `case` in that switch. A group's `key` is
// the tab value for its own overview page.
//
// "Konti" (Sohoka / logout) is not a tab, so it is not listed here —
// AppLayout renders it as a pinned footer action.

export const NAV_GROUPS = [
  {
    key: "rusange",
    label: "Rusange",
    icon: "bi-grid-1x2-fill",
    color: "#7c3aed",
    description: "Ahabanza h'ibikorwa byawe bya buri munsi.",
    children: [
      { key: "overview", label: "Dashboard", icon: "bi-house-fill", description: "Incamake y'ibikorwa n'imibare y'ingenzi." },
    ],
  },
  {
    key: "abaturage-ingo",
    label: "Abaturage n'Ingo",
    icon: "bi-people-fill",
    color: "#0f766e",
    description: "Amakuru y'abaturage, ingo n'amasibo.",
    children: [
      { key: "abaturage", label: "Abaturage", icon: "bi-people-fill", description: "Reba no gucunga abaturage bose." },
      { key: "ingo", label: "Ingo", icon: "bi-house-door-fill", description: "Amakuru y'ingo zo mu mudugudu." },
      { key: "isibo", label: "Isibo", icon: "bi-geo-alt-fill", description: "Amasibo n'abayakuriye." },
    ],
  },
  {
    key: "imibereho",
    label: "Imibereho Myiza",
    icon: "bi-heart-fill",
    color: "#be123c",
    description: "Imibereho myiza n'abagize inzitizi.",
    children: [
      { key: "imibereho", label: "Imibereho", icon: "bi-heart-fill", description: "Kurikirana imibereho myiza y'abaturage." },
      { key: "urubyiruko", label: "Urubyiruko", icon: "bi-person-arms-up", description: "Amakuru yerekeye urubyiruko." },
      { key: "abana", label: "Abana", icon: "bi-emoji-smile-fill", description: "Amakuru yerekeye abana." },
      { key: "abasheshe", label: "Abageze mu Izabukuru", icon: "bi-person-badge-fill", description: "Kurikirana abageze mu zabukuru." },
      { key: "inkunga", label: "Inkunga", icon: "bi-gift-fill", description: "Inkunga abaturage bahawe na Leta." },
      { key: "abana-binzererezi", label: "Abana Bari mu Mihanda", icon: "bi-signpost-split", description: "Kurikirana abana bari mu mihanda." },
      { key: "umusanzuEjoheza", label: "Umusanzu EjoHeza", icon: "bi-piggy-bank-fill", description: "Umusanzu wa Ejo Heza w'abaturage." },
    ],
  },
  {
    key: "ubuzima-uburezi",
    label: "Ubuzima n'Uburezi",
    icon: "bi-hospital-fill",
    color: "#0369a1",
    description: "Ubuzima, uburezi n'ubwishingizi.",
    children: [
      { key: "ubuzima", label: "Ubuzima", icon: "bi-heart-pulse-fill", description: "Amakuru y'ubuzima bw'abaturage." },
      { key: "uburezi", label: "Uburezi", icon: "bi-mortarboard-fill", description: "Amakuru y'uburezi bw'abaturage." },
      { key: "ubwishingizi", label: "Ubwishingizi", icon: "bi-shield-check", description: "Ubwishingizi bwo kwivuza (Mituweli)." },
    ],
  },
  {
    key: "ubukungu",
    label: "Ubukungu",
    icon: "bi-currency-exchange",
    color: "#b45309",
    description: "Amakuru y'ubukungu bw'abaturage.",
    children: [
      { key: "ubukungu", label: "Ubukungu", icon: "bi-currency-exchange", description: "Imirimo, umutungo n'injyana by'abaturage." },
    ],
  },
  {
    key: "isuku-remezo",
    label: "Isuku n'Ibikorwa Remezo",
    icon: "bi-stars",
    color: "#0891b2",
    description: "Isuku, imyanda n'ibikorwa remezo.",
    children: [
      { key: "kurwanyaUmwanda", label: "Kurwanya Umwanda", icon: "bi-trash-fill", description: "Guhashya umwanda mu mudugudu." },
      { key: "isukuIsukura", label: "Isuku n'Isukura", icon: "bi-stars", description: "Isuku n'isukura by'ingo." },
      { key: "ibikorwa-remezo", label: "Ibikorwa Remezo", icon: "bi-building-gear", description: "Ibikorwa remezo by'umudugudu." },
    ],
  },
  {
    key: "umutekano",
    label: "Umutekano, Ubutabera n'Imyitwarire",
    icon: "bi-shield-lock-fill",
    color: "#7c3aed",
    description: "Umutekano, ibirego, amacyimbirane n'imyitwarire.",
    children: [
      { key: "umutekano-leader", label: "Umutekano", icon: "bi-shield-lock-fill", description: "Ibikorwa by'umuyobozi w'umutekano." },
      { key: "isibo-ibirego", label: "Ibirego", icon: "bi-file-earmark-text", description: "Ibirego bivuye ku masibo." },
      { key: "amacyimbirane", label: "Amacyimbirane", icon: "bi-exclamation-triangle-fill", description: "Amakimbirane mu ngo no mu mudugudu." },
      { key: "imico-imyifatire", label: "Imico n'Imyifatire", icon: "bi-award-fill", description: "Impamyabumenyi z'imico n'imyifatire." },
      { key: "abashyitsi-dufite", label: "Abashyitsi", icon: "bi-person-lines-fill", description: "Abashyitsi bageze mu mudugudu." },
    ],
  },
  {
    key: "ibikorwa-isibo",
    label: "Ibikorwa by'Isibo",
    icon: "bi-clipboard2-check-fill",
    color: "#0d9488",
    description: "Ibikorwa n'ubwitabire bivuye ku masibo.",
    children: [
      { key: "isibo-attendance", label: "Attendance", icon: "bi-clipboard2-check-fill", description: "Ubwitabire bwoherejwe n'amasibo." },
    ],
  },
  {
    key: "raporo",
    label: "Amaraporo",
    icon: "bi-file-earmark-text-fill",
    color: "#1d4ed8",
    description: "Kwandika no kohereza amaraporo.",
    children: [
      { key: "kwandikaRaporo", label: "Kwandika Raporo", icon: "bi-pencil-square", description: "Andika raporo nshya y'ibikorwa." },
      { key: "raporo", label: "Raporo z'Ibikorwa", icon: "bi-bar-chart-fill", description: "Reba raporo z'ibikorwa by'umudugudu." },
      { key: "raporoZoherejwe", label: "Raporo Zoherejwe", icon: "bi-file-earmark-arrow-down-fill", description: "Raporo wamaze kohereza n'aho zigeze." },
      { key: "villageInfo", label: "Amakuru y'Umudugudu", icon: "bi-house-gear-fill", description: "Tanga/hindura amakuru y'umudugudu." },
    ],
  },
  {
    key: "itumanaho",
    label: "Itumanaho",
    icon: "bi-chat-dots-fill",
    color: "#15803d",
    description: "Ubutumwa, amatangazo n'ibibazo.",
    children: [
      { key: "messaging", label: "Kohereza Ubutumwa", icon: "bi-envelope-fill", description: "Andika kandi wohereze ubutumwa bushya." },
      { key: "amatangazo", label: "Amatangazo", icon: "bi-megaphone-fill", description: "Amatangazo yo mu mudugudu." },
      { key: "amatangazoAkagari", label: "Amatangazo y'Akagari", icon: "bi-megaphone-fill", description: "Amatangazo aturutse ku kagari." },
      { key: "oherezaIkibazo", label: "Ohereza Ikibazo", icon: "bi-chat-square-text-fill", description: "Ohereza ikibazo ku buyobozi bwo hejuru." },
      { key: "ibibazoByanye", label: "Ibibazo Byanjye", icon: "bi-inbox-fill", description: "Ibibazo woherejwe n'ibisubizo byabyo." },
    ],
  },
  {
    key: "ubuyobozi",
    label: "Ubuyobozi n'Igenamiterere",
    icon: "bi-person-gear",
    color: "#475569",
    description: "Gucunga abayobozi b'umudugudu.",
    children: [
      { key: "Umuyobozi", label: "Umuyobozi", icon: "bi-person-plus-fill", description: "Ongeramo umuyobozi mushya w'umudugudu." },
      { key: "guhinduraUmuyobozi", label: "Hindura Umuyobozi", icon: "bi-person-gear", description: "Hindura amakuru y'umuyobozi uriho." },
    ],
  },
];

/**
 * Returns the trail for `key`:
 *   - a group key           -> [group]
 *   - a leaf key            -> [group, leaf]
 *   - not found (e.g. bnav) -> null
 * Powers the breadcrumb + sidebar active-state.
 */
export function findLeafPath(groups, key) {
  for (const group of groups) {
    if (group.key === key) return [group];
    const path = searchNode(group, key, [group]);
    if (path) return path;
  }
  return null;
}

/** The group a given leaf key belongs to, or null. */
export function findGroupForKey(groups, key) {
  return groups.find((g) => (g.children || []).some((c) => c.key === key)) || null;
}

function searchNode(node, leafKey, trail) {
  if (!node.children) {
    return node.key === leafKey ? trail : null;
  }
  for (const child of node.children) {
    const result = searchNode(child, leafKey, [...trail, child]);
    if (result) return result;
  }
  return null;
}
